import { render, staticRenderFns } from "./AccountingPaymentDetail.vue?vue&type=template&id=640f0e3b&"
import script from "./AccountingPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./AccountingPaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./AccountingPaymentDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports